// Resolves the browser-tab identity (title + favicon) a target-facing landing page should show,
// so the tab impersonates the same brand as the landing page instead of revealing Boxphish.
// Detection is keyword based on the simulation's landing-page path and name; anything we cannot
// place falls back to a neutral, unbranded tab rather than the Boxphish default.

// 1x1 transparent PNG: a neutral favicon that shows no brand (and no Boxphish) for custom pages.
const BLANK_ICON =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=";

const BRANDS = [
    {
        test: /google|gmail/i,
        title: "Gmail",
        icon: "https://www.google.com/favicon.ico"
    },
    {
        test: /microsoft|office|outlook|o365|m365|two\s+stage/i,
        title: "Sign in to your Microsoft account",
        icon: "https://logincdn.msauth.net/16.000.28328.6/images/favicon.ico"
    }
];

export const NEUTRAL_TAB_IDENTITY = { title: "Sign in", icon: BLANK_ICON };

export function resolveLandingTabIdentity(signal) {
    // Landing-page paths encode spaces as %20 or +; normalise so keyword matching is not fooled by encoding.
    const normalized = (signal || "").replace(/%20|\+/g, " ");
    const brand = BRANDS.find((entry) => entry.test.test(normalized));
    return brand ? { title: brand.title, icon: brand.icon } : NEUTRAL_TAB_IDENTITY;
}
